import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    isSubmitLoading: false
}

export const createCarTForm = createAsyncThunk(
    'outbound/createOutbondForm',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/car-t-manufacturing-form/submit`, data);
            notify.success(response.data.message)
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

export const ApproveCarTForm = createAsyncThunk(
    'outbound/ApproveCarTForm',
    async (args, { rejectWithValue }) => {
        try {
            const { data, id } = args
            const response = await api.put(`/car-t-manufacturing-form/update/${id}`, data);
            notify.success(response.data.message)
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

// fetch all Car T Form
export const fetchCarTFormDetails = createAsyncThunk(
    'bmr/fetchCarTFormDetails',
    async (args, { rejectWithValue }) => {
        try {
            const { product_manufacturing_id, id } = args
            const response = await api.get(`/car-t-manufacturing-form/${id}/${product_manufacturing_id  }/details`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

//Reject LSM ket
export const rejectedUCCoaForm = createAsyncThunk(
  "bmr/coa-form/qc-lead",
  async (args, { rejectWithValue }) => {
    try {
      const { id, data } = args
      const response = await api.put(`/coa-form/qc-lead/fail/${id}`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(
          error || error.message || error.response || error.response.data
        )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);





const CarTFormSlice = createSlice({
    name: "cartForm",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createCarTForm.pending, (state) => {
                state.isSubmitLoading = true;
            })
            .addCase(createCarTForm.fulfilled, (state) => {
                state.isSubmitLoading = false;
            })
            .addCase(createCarTForm.rejected, (state) => {
                state.isSubmitLoading = false;
            })
            .addCase(fetchCarTFormDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCarTFormDetails.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchCarTFormDetails.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(ApproveCarTForm.pending, (state) => {
                state.isSubmitLoading = true;
            })
            .addCase(ApproveCarTForm.fulfilled, (state) => {
                state.isSubmitLoading = false;
            })
            .addCase(ApproveCarTForm.rejected, (state) => {
                state.isSubmitLoading = false;
            })
    }
})

export const selectIsLoading = (state) => state.cartForm.isLoading;
export const selectIsSubmitLoading = (state) => state.cartForm.isSubmitLoading;

export default CarTFormSlice.reducer;